import { Context } from "src/app/shared/models/interface/concretes/context.interface";
import { transformBrand } from "src/app/shared/utils/brand-utils";

export class CreateContextRequestBuilder {
  private requestData: any;

  constructor() {
    this.requestData = {
      codeReseau: null,
      codeOperation: "DROIT_CREATE_DEVIS",
      idVendeur: 0,
      modeConnexion: "COB",
      idGestionaire: 0,
      referenceDevis: null,
      produit: "MRH",
      branche: "MRH",
      souscripteur: {
        civilite: null,
        prenom: null,
        nom: null,
        dateNaissance: null,
        paysNaissance: null,
        departementNaissance: null,
        villeNaissance: null,
        adresse: null,
        adresse2: null,
        codePostal: null,
        ville: null,
        telephone: null,
        email: null,
        profil: null,
        typologieSouscripteur: "p",
      },
      codeVendeur: "VY",
      nomVendeur: null,
      prenomVendeur: null,
      siteVendeur: "000001",
      canalVente: "W",
      referenceContrat: null,
      typeContact: null,
      donneesPartenaire: null,
    };
  }

  withProduit(produit: string | null): CreateContextRequestBuilder {
    this.requestData.produit = produit?.toUpperCase() || null;
    return this;
  }

  withCodeVendeur(codeVendeur: string | null): CreateContextRequestBuilder {
    this.requestData.codeVendeur = transformBrand(codeVendeur ?? "");
    return this;
  }

  private validate(): void {
    if (!this.requestData.produit) {
      throw new Error("Produit est requis.");
    }
  }

  build(): Context {
    this.validate();
    return this.requestData;
  }
}
